/*

  TabBar.ts

  Reusable tab navigation component

  Copyright (C) 2025 Miðeind ehf.
  Author: Vilhjálmur Þorsteinsson

  The Creative Commons Attribution-NonCommercial 4.0
  International Public License (CC-BY-NC 4.0) applies to this software.
  For further information, see https://github.com/mideind/Netskrafl

*/

import { Component, m } from "./mithril";
import { glyph } from "./util";

export interface ITab {
  id: string;
  label: string;
  icon?: string; // Optional emoji or icon character (deprecated, use iconGlyph)
  iconGlyph?: string; // Glyphicon name (e.g., "dashboard", "stats")
  badgeGlyph?: string; // Optional badge glyph (e.g., "star") shown on top of the icon
}

interface ITabBarAttributes {
  tabs: ITab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

export const TabBar: Component<ITabBarAttributes> = {
  view: (vnode) => {
    const { tabs, activeTab, onTabChange } = vnode.attrs;

    return m(".tab-bar",
      tabs.map(tab =>
        m(
          ".tab-item" + (activeTab === tab.id ? ".active" : ""),
          {
            key: tab.id,
            onclick: () => onTabChange(tab.id)
          },
          [
            m("span.tab-icon-wrapper", [
              tab.iconGlyph ? m("span.tab-icon", glyph(tab.iconGlyph)) :
              tab.icon ? m("span.tab-icon", tab.icon) : null,
              tab.badgeGlyph ? m("span.tab-badge", glyph(tab.badgeGlyph)) : null
            ]),
            m("span.tab-label", tab.label)
          ]
        )
      )
    );
  }
};
